"use client"
import React from 'react';
import { toast, ToastOptions } from 'react-toastify';
import { BaseToast } from './baseToast';

type ShowToastOptions = {
    content: React.ReactNode;
    options?: ToastOptions;
    onCloseClick?: () => void;
};

export const showToast = ({ content, options, onCloseClick }: ShowToastOptions) => {
    toast(
        (props) => (
            <BaseToast {...props} onCloseClick={onCloseClick}>
                {content}
            </BaseToast>
        ),
        {
            ...options
        }
    );
};
